'use strict'

import {mainForm} from "../scripts/components/Form.js"

const damageForm = document.querySelector('form.damage-form')
if (damageForm) new mainForm(damageForm)

